export const ApplicationStatus = {
    Commenced: "Commenced",
    Completed: "Completed",
    "Compliance Report": "Compliance Report",
    Pending: "Pending",
    Refused: "Refused",
    Closed: "Closed",
    "Fee Check": "Fee Check",
    "Pre-Validation Checks": "Pre-Validation Checks",
    "NO FURTHER ACTION": "NO FURTHER ACTION",
    Monitoring: "Monitoring",
    Invalid: "Invalid",
    Archived: "Archived",
    "Not Applicable": "Not Applicable",
} as const;

export type ApplicationStatus = typeof ApplicationStatus[keyof typeof ApplicationStatus];

export const AppStatusesNotEditable = [
    ApplicationStatus.Closed,
    ApplicationStatus.Archived,
    ApplicationStatus.Refused,
    ApplicationStatus.Completed,
    ApplicationStatus["Not Applicable"],
] as string[];
